import { Injectable } from '@angular/core'
import { AccountUser, UserRole } from '@app/domain/AccountUser'

export enum Ability {
    ManageBilling,
    DeleteUser,
    EditUser,
    AuditOrganisation,
    WriteBooking,
}

@Injectable({
    providedIn: 'root',
})
export class PermissionService {

    doesUserHaveAbility(user: AccountUser, ability: Ability): boolean {
        return new RoleAuthorizer(user).permits(ability)
    }
}

class RoleAuthorizer {

    private ownerPermittedAbilities: Ability[] = [
        Ability.ManageBilling,
        Ability.DeleteUser,
        Ability.EditUser,
        Ability.AuditOrganisation,
        Ability.WriteBooking,
    ]
    private managerPermittedAbilities: Ability[] = [
        Ability.EditUser,
        Ability.WriteBooking,
    ]

    constructor(
        private user: AccountUser
    ) { }

    permits(ability: Ability): boolean {
        switch (this.user.role) {
        case UserRole.OWNER:
            return this.ownerPermits(ability)
        case UserRole.MANAGER:
            return this.managerPermits(ability)
        case UserRole.STAFF:
            return ability === Ability.WriteBooking
        case UserRole.VIEWER:
            return false
        }
    }

    private ownerPermits(ability: Ability): boolean {
        return this.ownerPermittedAbilities.includes(ability)
    }

    private managerPermits(ability: Ability): boolean {
        return this.managerPermittedAbilities.includes(ability)
    }
}
